/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Sun = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12.75 19V23H11.25V19H12.75ZM17.4801 16.4194L20.3085 19.2478L19.2478 20.3085L16.4194 17.4801L17.4801 16.4194ZM6.51992 16.4194L7.58058 17.4801L4.75216 20.3085L3.6915 19.2478L6.51992 16.4194ZM12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5ZM23 11.25V12.75H19V11.25H23ZM5 11.25V12.75H1V11.25H5ZM19.2478 3.6915L20.3085 4.75216L17.4801 7.58058L16.4194 6.51992L19.2478 3.6915ZM4.75216 3.6915L7.58058 6.51992L6.51992 7.58058L3.6915 4.75216L4.75216 3.6915ZM12.75 1V5H11.25V1H12.75Z"
                        fill={color}
                    />
                </svg>
        );
    };
